module.exports = __webpack_public_path__ + "static/assets/9a38ab8b8c4234070e4caa166ce4a83e.png";